import Http from "./base-http";

class Budget extends Http {
  deleteBudget(id) {
    return this.destroy(id);
  }
  addBudget(variables) {
    return this.create(variables);
  }
}

const budgetObj = new Budget({
  modelUrlPrefix : "budget"
});

export default budgetObj;